import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { fromEvent, of, Subject } from 'rxjs';
import { filter, takeUntil, switchMap } from 'rxjs/operators';

import { InterstitialModalComponent } from '@finder/shared/components/interstitial-modal/interstitial-modal.component';
import { INTERSTITIAL_CLASSES, INTERSTITIAL_LABELS } from './interstitial-trigger.defaults';
import { ModalService } from '@finder/shared/components/modal/modal.service';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';

@Directive({
    selector: '[finderInterstitialTrigger]'
})
export class InterstitialTriggerDirective implements AfterViewInit, OnDestroy {

    // set default value in case the bundle service fails
    @Input() interstitialLabels: any = INTERSTITIAL_LABELS;

    interstitialModal: ModalComponent;
    private destroy$ = new Subject<void>();

    constructor(
        private elementRef: ElementRef,
        private modalService: ModalService,
    ) { }

    /* istanbul ignore next */
    getElementRef(): Element {
        return this.elementRef.nativeElement;
    }

    ngAfterViewInit() {
        fromEvent(this.getElementRef(), 'click')
            .pipe(
                filter((event: any) => {
                    const element: HTMLElement = event.target;

                    // take only anchors with interstitial classes applied
                    return element instanceof HTMLAnchorElement &&
                        INTERSTITIAL_CLASSES.some(cl => element.classList.contains(cl));
                }),
                switchMap((event: any) => {
                    // avoid the event to bubble to the syndicated header
                    // that way we make sure only our modal is triggered
                    event.stopPropagation();
                    // intercept redirection
                    event.preventDefault();

                    // if the modal is already created, we just update the data
                    if (this.interstitialModal) {
                        this.interstitialModal.config.data = {
                            ...this.interstitialModal.config.data,
                            href: event.target.href
                        };

                        return of(true);
                    }

                    this.interstitialModal = this.modalService.create(
                        InterstitialModalComponent,
                        {
                            title: this.interstitialLabels.title,
                            data: {
                                labels: this.interstitialLabels,
                                href: event.target.href
                            }
                        }
                    );

                    // wait until the modal is created and ready to launch
                    return this.interstitialModal.ready();
                }),
                takeUntil(this.destroy$)
            )
            .subscribe(() => this.interstitialModal.open());
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
